import React from 'react';
import PageLayout from '../../layout/PageLayout';
import RnkimContent from '../../layout/RnkimContent';

const RnkimContentPage: React.FC = () => (
  <PageLayout>
    <RnkimContent />
  </PageLayout>
);

export default RnkimContentPage;
